import { FileText, MapPin, Package, Truck } from "lucide-react"

import type { priceRoute } from "@/lib/routeCostCalculation"
import type { PlannedRoute } from "@/types/collections"

export function TimelineSummaryBar({
  routes,
  routeCosts,
  showCost,
  getVolumeForecastForStop,
}: {
  routes: PlannedRoute[]
  routeCosts: Map<string, ReturnType<typeof priceRoute>>
  showCost: boolean
  getVolumeForecastForStop: (route: PlannedRoute, stop: { locationId?: string }) => number
}) {
  return (
    <div className="bg-palette-jungleGreen000 border-b border-palette-jungleGreen200 px-4 py-2 flex-shrink-0">
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2">
          <Truck size={14} className="text-blue-500" />
          <span className="text-xs text-palette-jungleGreen500">Routes:</span>
          <span className="text-sm font-semibold text-palette-jungleGreen900">
            {routes.length}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <MapPin size={14} className="text-emerald-500" />
          <span className="text-xs text-palette-jungleGreen500">Stops:</span>
          <span className="text-sm font-semibold text-palette-jungleGreen900">
            {routes.reduce((sum, r) => sum + r.stops.length, 0)}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Package size={14} className="text-purple-500" />
          <span className="text-xs text-palette-jungleGreen500">Est. Volume:</span>
          <span className="text-sm font-semibold text-palette-jungleGreen900">
            {routes
              .reduce(
                (sum, r) =>
                  sum +
                  r.stops.reduce((acc, stop) => acc + getVolumeForecastForStop(r, stop), 0),
                0,
              )
              .toLocaleString()}
          </span>
          <span className="text-xs text-palette-jungleGreen400">items</span>
        </div>
        {showCost && (
          <div className="flex items-center gap-2">
            <FileText size={14} className="text-amber-500" />
            <span className="text-xs text-palette-jungleGreen500">Est. Cost:</span>
            <span className="text-sm font-semibold text-palette-jungleGreen900">
              £
              {routes
                .reduce((sum, r) => {
                  const cost = routeCosts.get(r.id)
                  return sum + (cost?.total_cost || 0)
                }, 0)
                .toLocaleString("en-GB", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}
